import I18n from 'i18n-js';
import React from 'react';
import { shuffle } from 'lodash';

import CuratedSet from './curated_set';
import CuratedSetRowStore from './stores/curated_set_row_store';
import CuratedSetCard from './curated_set_card';

import OverflowingRow from '@reverbdotcom/commons/src/components/overflowing_row';
import Tiles from '@reverbdotcom/commons/src/components/tiles';

import { CURATED_SET_ROW_LENGTH } from '../shared/constants';

interface State {
  curated_sets: CuratedSet[];
}

interface Props {
  shouldShuffle?: boolean;
  showHeading?: boolean;
  linkParams?: Record<string, any>;
  title?: string;
  action?: JSX.Element;
  centeredTitle?: boolean;
}

export default class CuratedSetRow extends React.Component<Props, State> {
  static defaultProps: Partial<Props> = {
    shouldShuffle: true,
    centeredTitle: false,
  };

  constructor(props) {
    super(props);

    this.state = {
      curated_sets: CuratedSetRowStore.getState().curated_sets,
    };

    this.onRowUpdate = this.onRowUpdate.bind(this);
  }

  componentDidMount() {
    CuratedSetRowStore.listen(this.onRowUpdate);
  }

  componentWillUnmount() {
    CuratedSetRowStore.unlisten(this.onRowUpdate);
  }

  onRowUpdate() {
    const { curated_sets } = CuratedSetRowStore.getState();

    this.setState({ curated_sets });
  }

  hasEnoughCuratedSets() {
    return this.state.curated_sets.length >= CURATED_SET_ROW_LENGTH;
  }

  getHeading() {
    if (!this.props.showHeading && !this.props.title) { return null; }

    return this.props.title || I18n.t('discovery.curatedSetRow.header');
  }

  render() {
    if (!this.hasEnoughCuratedSets()) { return null; }

    const curated_sets = this.props.shouldShuffle ?
      shuffle(this.state.curated_sets) as CuratedSet[] :
      this.state.curated_sets;

    return (
      <OverflowingRow
        title={this.getHeading()}
        centeredTitle={this.props.centeredTitle}
        action={this.props.action}
      >
        <Tiles
          largeTiles
          singleRow
          grow
        >
          {curated_sets.map((curatedSet, idx) => (
            <CuratedSetCard
              curatedSet={curatedSet}
              linkParams={this.props.linkParams}
              key={idx}
            />
          ))}
        </Tiles>
      </OverflowingRow>
    );
  }
}
